// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { createSelector } from 'reselect';

import { RootState } from '../../rootReducer';
import { Selector } from 'react-redux';
import { ProductCard } from '../../../components/NewCard/types';
import { KeywordTitle } from '../../actionCreators/search/searchExamsKeywordActions';
import { useContext } from 'react';
import CommonContext from '../../../contexts/CommonContext';
import { getMultilangs } from '../../../components/common/Multilang';
import { similarWordPoints } from '../../../lib/utility';
import { SearchExamsState } from '../../reducers/searchExamsReducer';

export const searchExamsRaw = (state: RootState): SearchExamsState => state.searchExamsReducer;

export const makeSearchExams = (): Selector<RootState, ProductCard[]> => {
  return createSelector(
    searchExamsRaw,
    (searchExamsReducer) => searchExamsReducer.examsListData.list
  );
};

export const makeIsFetching = (): Selector<RootState, boolean> =>
  createSelector(
    searchExamsRaw,
    (searchExamsReducer) => searchExamsReducer.isFetching
  );

export const makeError = (): Selector<RootState, Error | undefined> =>
  createSelector(
    searchExamsRaw,
    (searchExamsReducer) => searchExamsReducer.error
  );

export const makeHasMore = (): Selector<RootState, boolean> =>
  createSelector(
    searchExamsRaw,
    (searchExamsReducer) =>
      searchExamsReducer.examsListData.totalPage > searchExamsReducer.examsListData.page
  );

export const makeSearchKeywordByKey = (key: string): Selector<RootState, KeywordTitle[]> => {
  return createSelector(
    searchExamsRaw,
    (searchExamsReducer) => searchExamsReducer.examsKeyword[key]
  );
};

export const makeSearchCommonKeywordByKey = (key: string): Selector<RootState, KeywordTitle[]> => {
  return createSelector(
    searchExamsRaw,
    () => {
      const common = useContext(CommonContext);
      const filteredDomains = getMultilangs(common.domains)
        .filter((domain) => similarWordPoints(domain.name, key) > 0.5)
        .map((domain) => ({ name: domain.name, id: -1 }));
      const filteredPlatforms = getMultilangs(common.platforms)
        .filter((platform) => similarWordPoints(platform.name, key) > 0.5)
        .map((platform) => ({ name: platform.name, id: -1 }));

      return [
        ...filteredPlatforms, ...filteredDomains
      ]
    }
  )
}

export const makeIsMoreFetching = (): Selector<RootState, boolean> =>
  createSelector(
    searchExamsRaw,
    (searchExamsReducer) => searchExamsReducer.isFetchingMore
  );
